/* eslint-disable jsx-a11y/anchor-is-valid */
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import { useAuth} from '../../../auth'

import { useNavigate } from "react-router-dom";
import { StatusErrorMessage } from '../../../../components/widgets'
import { doFormSubmit } from '../../../../components/helpers'


const onboardOTPSchema = Yup.object().shape({    
  otp: Yup.string().trim()
    .min(2, 'Minimum 2 symbols')
    .max(16, 'Maximum 16 symbols')
    .required('OTP is required'),
})

const initialValues = {
  otp: '',    
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function CompanyOnboardOTP() {

  const navigate = useNavigate();
  const {auth} = useAuth()
  
  const formik = useFormik({
    initialValues,    
    validationSchema: onboardOTPSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {      
      await doFormSubmit('OnBoardingOTPServlet', { id: (auth ? auth.id : -1), otp: values.otp }, setStatus, setSubmitting, () => {
        alert("Company onboarding successful!");
        navigate('/auth');                           
      });
    },
  })

  return (
  <>
  <form
    className="form w-100 w-lg-400px bg-white rounded-4 overflow-hidden"
    onSubmit={formik.handleSubmit}
    noValidate
    id='kt_login_signin_form'
  >
    <div className="p-10 d-flex flex-column gap-6 mb-10">
      <div className="text-center text-primary fw-bold fs-1">
        Company Onboarding
      </div>
  
      <div className="text-center text-primary fw-light fs-2">
        Please check your email for OTP
      </div>
      <div className='fv-row'>                
        <input
          placeholder='OTP'
          {...formik.getFieldProps('otp')}
          className={clsx(
            'form-control bg-transparent',
            {'is-invalid': formik.touched.otp && formik.errors.otp},
            {'is-valid': formik.touched.otp && !formik.errors.otp,}
          )}
          type='input'
          name='otp'
          autoComplete='off'
        />
        {formik.touched.otp && formik.errors.otp && (
        <div className='fv-plugins-message-container'>                    
          <div className='fv-help-block'>
            <span role='alert'>{formik.errors.otp}</span>
          </div>
        </div>
        )}
      </div>

      <StatusErrorMessage status={formik.status} />
      
      <div className="d-flex flex-stack flex-wrap gap-3 justify-content-start align-items-center">
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-primary px-10'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {(! formik.isSubmitting) && <span className='indicator-label'>Submit OTP</span>}
          {formik.isSubmitting && (
          <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
          </span>
          )}
        </button>                
        <Link to='/auth/login' className="link-primary">
            Back to Login
        </Link>        
        <div />        
      </div>    
    </div>        
  </form>
  </>
  )
}
